/**
 * URLs oficiales de las tecnologías mostradas en la sección About
 */
export const TECH_URLS: Record<string, string> = {
  // Unity & XR
  'Unity3D': 'https://unity.com',
  'AR/VR/MR': 'https://unity.com/unity/features/ar',
  'WebXR': 'https://immersiveweb.dev',
  'Digital Twins': 'https://unity.com/solutions/digital-twins',
  'HoloLens 2': 'https://www.microsoft.com/en-us/hololens',
  'Meta Quest': 'https://www.meta.com/quest',
  'Pico': 'https://www.picoxr.com',
  'HTC Vive': 'https://www.vive.com',

  // Full Stack Web & Code
  'React': 'https://react.dev',
  'Next.js': 'https://nextjs.org',
  'TypeScript': 'https://www.typescriptlang.org',
  'JavaScript': 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
  'Supabase': 'https://supabase.com',
  'Netlify': 'https://www.netlify.com',
  'Docker': 'https://www.docker.com',
  'Java': 'https://www.oracle.com/java',
  'C#': 'https://learn.microsoft.com/en-us/dotnet/csharp',
  'Python': 'https://www.python.org',

  // 3D & Rendering
  'Unity WebGL': 'https://unity.com/solutions/webgl',
  '3ds Max': 'https://www.autodesk.com/products/3ds-max',
  'V-Ray': 'https://www.chaos.com/vray',

  // AI Tools
  'Claude Code': 'https://claude.ai/code',
  'Cursor AI': 'https://cursor.sh',
  'ChatGPT': 'https://chat.openai.com',
  'LangChain/LangGraph': 'https://www.langchain.com',
  'RAG': 'https://www.langchain.com/rag',
  'Embeddings': 'https://platform.openai.com/docs/guides/embeddings',
  'Vector DB': 'https://www.pinecone.io',
  'Fine-tuning': 'https://platform.openai.com/docs/guides/fine-tuning',
  'AI Agents': 'https://www.anthropic.com',

  // Tools & Version Control
  'Git': 'https://git-scm.com',
  'Rider': 'https://www.jetbrains.com/rider',
  'VSCode': 'https://code.visualstudio.com',
  'PhpStorm': 'https://www.jetbrains.com/phpstorm',
  'Cursor': 'https://cursor.sh',

  // DevOps & Cloud
  'AWS': 'https://aws.amazon.com',
  'Google Cloud': 'https://cloud.google.com',
  'Azure': 'https://azure.microsoft.com',
};
